module.exports = __webpack_public_path__ + "img/icon_arrow_r.ee1d1e90.svg";